<template>
  <Modal ref="modal">
    <div slot="content" style="margin-top: 40px; margin-bottom: 40px;">
      <b>내 글을 정말 삭제</b>하시겠습니까?
    </div>
    <div slot="buttons">
      <button @click="clickNo" style="flex-grow: 1;">취소</button>
      <button @click="clickYes" style="flex-grow: 1;">삭제</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modal/Modal'

export default {
  name: 'DeleteAnswerModal',
  components: {
    Modal,
  },
  methods: {
    async clickYes() {
      this.$emit('executeDelete')
    },
    async clickNo() {
      this.$emit('cancelDelete')
    },
  }
}
</script>

<style lang="scss" scoped>
  .buttons {
    button {
      &:nth-child(odd) {
        color: #727d8c;
        background-color: #d7e1ea;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(even) {
        color: #ffffff;
        background-color: #333333;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
